<template>
<div v-if="file_to_preview">
    <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex gap-2"><!-- Left: stepper -->
            <template v-if="viewable_file_list?.length > 1">
                <button class="btn ion-chevron-left" :class="{'btn-secondary': prev_file}" :disabled="!prev_file" @click="file_to_preview = prev_file">
                </button>
                <select class="form-control" v-model="file_to_preview" name="file_to_preview">
                    <option 
                        v-for="file in viewable_file_list" 
                        :key="`${file.id}-${file.version_id || 0}`" 
                        :value="file">{{ file.name }}<template v-if="file.version_number"> ({{ file.version_number }})</template></option>
                </select>
                <button class="btn ion-chevron-right"  :class="{'btn-secondary': next_file}" :disabled="!next_file" @click="file_to_preview = next_file">
                </button>
            </template>
        </div>
        <div><!-- Right: save button -->
            <a :disabled="!file_to_preview.blob_url" :href="file_to_preview.blob_url" :download="file_to_preview.name" class="btn btn-brand ml-2 text-initial">
                <i class="ion-arrow-down-a mr-2"></i> Save to Computer
            </a>
        </div>
    </div>
    <div class="mt-3 text-center">
        <div v-if="file_to_preview.loading">
            <div class="progress mt-2 mx-auto" style="max-width: 50%;">
                <div class="progress-bar progress-bar-primary progress-bar-striped progress-bar-animated" role="progressbar" :aria-valuenow="file_to_preview.loading" aria-valuemin="0" aria-valuemax="100" :style="{'width': Math.round(file_to_preview.loading)+'%'}">
                <span class="sr-only">{{Math.round(file_to_preview.loading)}}% complete</span></div>
            </div>
        </div>
        <file-preview
            v-else-if="file_to_preview.blob_url"
            :blob_url="file_to_preview.blob_url"
            :file_name="file_to_preview.name"
            :mime_type="file_to_preview.mime_type"
            :viewer_name="file_to_preview.viewer.name">
        </file-preview>
    </div>
</div>
</template>

<script type="text/javascript">
import { Utils } from '@/helpers/utils.js'
import { FileDownloader } from '@/helpers/file-downloader.js';
import filePreview from './file-preview.vue'
import { bus, events } from '@/helpers/event_bus';

export default {

    props: {
        
        // The viewable file to open the viewer with. When the `version_id` attribute is set, this specific version will be shown
        file: Object,

        // (optional) List of all previewable files (optionally with `version_id` set) in the current context, including `props.file`
        // The viewer can step between them without having to close the modal
        viewable_file_list: {
            type: Array,
            default: () => []
        },

    },

    components: { filePreview },

    data(){
        return {
            text: null,
            file_to_preview: null,
        }

    },

    computed: {

        file_id(){ return this.file_to_preview ? `${this.file_to_preview.id}-${this.file_to_preview.version_id || 0}` : null  },

        current_file_idx(){
            return this.file_to_preview ? this.viewable_file_list.findIndex(f => this.is_same_file(f, this.file_to_preview)) : null
        },

        prev_file(){
            // Previous file we can switch to, or null if the current file is the first
            if(this.current_file_idx == null){ return null }
            return this.current_file_idx <= 0 ? null : this.viewable_file_list[this.current_file_idx-1]
        },

        next_file(){
            // Next file we can switch to, or null if the current file is the last
            if(this.current_file_idx == null){ return null }
            return this.current_file_idx >= this.viewable_file_list.length-1 ? null : this.viewable_file_list[this.current_file_idx+1]
        },
        
    },

    watch: {
        file_id(){
            this.preview_current_file()
            this.$emit('preview_file_changed', this.file_to_preview?.name)
        }
    },

    created(){
        // Start previewing the given file
        this.file_to_preview = this.viewable_file_list?.find(f => this.is_same_file(f, this.file)) || this.file
    },


    methods: {

        is_same_file(f1, f2){
            return f1.id === f2.id && f1.version_id === f2.version_id
        },

        preview_current_file(){
            // A new file is selected

            // Cancel ongoing download of the previously viewed file
            this.prev_file?.cancel?.();
            this.next_file?.cancel?.();

            if(this.file_to_preview.blob_url){
                // already downloaded
                return;
            }

            // Init the cancel field, it will be hooked up by the downloader
            this.$set(this.file_to_preview, 'cancel', {})
            // Tell the downloader to return the blob url instead of forcing download
            this.$set(this.file_to_preview, 'preview', true)
            
            const downloader = new FileDownloader()
            const version_id = this.file_to_preview.version_id || null
            downloader.downloadFile(this.file_to_preview, version_id).then(res => {
                this.file_to_preview.loading = false
                delete this.file_to_preview.cancel

                this.file_to_preview.blob_url = res.blob_url
                this.file_to_preview.mime_type = res.mime_type

            }).catch(err => {
                if(!err || !err.cancelled){
                    Utils.show_error("Error downloading file.")
                }
            })
        },

        jump_prev(){
            if(this.prev_file){ this.file_to_preview = this.prev_file }
        },
        jump_next(){
            if(this.next_file){ this.file_to_preview = this.next_file }
        }
    },

    mounted(){
        var self = this
        $(document).keyup(function(event) {
            if(event.which == 37) {
                event.preventDefault();
                self.jump_prev()
            }
            if(event.which === 39){
                event.preventDefault();
                self.jump_next()
            }
        });
    },

    destroyed(){
        $(document).unbind('keyup')
    }

}
</script>

<style lang="css" scoped>

    #container-table{
        table-layout: fixed;
        width: 100%
    }
    #container-table td{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .pager{
        width: 100px
    }
    .pager:hover{
        background: #ebebeb
    }
</style>
